import React, { useEffect, useRef, useState } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";

import QuotationDocumentContent from "./QuotationDocumentContent";

const QuotationDocument = ({
  closeModal,
  quotation,
  loadQuotation,
  loader,
  setLoader,
}) => {
 const componentRef = useRef(null);
  const contentRef = useRef(null);

 const reactToPrintFn = useReactToPrint({ 
    contentRef: componentRef,
    pageStyle: `
      @page {
        size: A4;
        margin: 0.5in;
        @top-left { content: ""; }
        @top-center { content: ""; }
        @top-right { content: ""; }
        @bottom-left { content: ""; }
        @bottom-center { content: ""; }
        @bottom-right { content: ""; }
      }
      @media print {
        body {
          font-size: 12px;
        }
        .no-print {
          display: none !important;
        }
        table {
          border-collapse: collapse;
          page-break-inside: auto;
        }
        thead {
          display: table-header-group;
        }
        tfoot {
          display: table-footer-group;
        }
        tr {
          page-break-inside: avoid;
          break-inside: avoid;
        }
      }
    `
  });

  // useEffect(() => {
  //   loadQuotation();
  // }, []);

  return (
    <div className="h-[90vh] flex py-1 bg-white" ref={contentRef}>
      <div className="flex relative gap-2 w-full h-full overflow-y-auto">
       
        <QuotationDocumentContent
          quotation={quotation}
          componentRef={componentRef}
        />
      </div>

      <div className="flex flex-col gap-2  top-2 right-5 bg-white py-2 px-2">
        <button
          type="button"
          onClick={reactToPrintFn}
          className="inline-flex w-40 justify-center items-center gap-2 py-1 px-2 border-2 border-sky-600 shadow-sm text-xs font-semibold rounded-md bg-sky-600 text-white focus:outline-none disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
        >
          <img src="print.svg" className="h-5" alt="Print" />
          Print
        </button>

        <button
          type="button"
          className="inline-flex float-right justify-center items-center gap-2 py-1 px-2 border-2 border-black shadow-sm text-xs font-semibold rounded-md bg-black text-white focus:outline-none disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
          onClick={() => closeModal()}
        >
          <img src="x.svg" className="h-5" /> Close
        </button>
      </div>
    </div>
  );
};

export default QuotationDocument;
